/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Leveling_Perm_Move_Members_HintInputs */



/**
* | output |
* | --- |
* | "Allows members to disconnect or move other members between voice channels that the member with this permission has access to." |
*
* @param {Leveling_Perm_Move_Members_HintInputs} inputs
* @param {{ locale?: "en" | "ru" }} options
* @returns {LocalizedString}
*/
export const leveling_perm_move_members_hint = /** @type {((inputs?: Leveling_Perm_Move_Members_HintInputs, options?: { locale?: "en" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Leveling_Perm_Move_Members_HintInputs, { locale?: "en" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ru") return /** @type {LocalizedString} */ ("Позволяет участникам отключать других участников от голосовых каналов и перемещать их между каналами, к которым у обладателя права есть доступ.")
	return /** @type {LocalizedString} */ ("Allows members to disconnect or move other members between voice channels that the member with this permission has access to.")
});